// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__CulEb","footerTitle":"Footer_footerTitle__I1rK+","copyright":"Footer_copyright__ji7jm"};